import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { CompareGeometrierDTO, GeometrierDuplicateDTO } from "~app/common/models/geometri/geometri";
import { IKartgeometri } from "~app/features/map/popups/kartgeometri-popup/kartgeometri.model";
import {
    ICollectorImportAtgarderRequest,
    ICollectorImportAtgarderResponse,
    ICollectorImportDrivningslinjerRequest,
    ICollectorImportDrivningslinjerResponse,
    ICollectorImportDrivningspunkterRequest,
    ICollectorImportDrivningspunkterResponse,
    ICollectorImportHansynslinjerRequest,
    ICollectorImportHansynslinjerResponse,
    ICollectorImportHansynspunkterRequest,
    ICollectorImportHansynspunkterResponse,
    ICollectorImportHansynsytorRequest,
    ICollectorImportHansynsytorResponse
} from "~app/features/virkeskop/models/atgard-collector-models";
import { ApiClientService } from "../../../../../services/api-client.service";

@Injectable({
    providedIn: "root"
})
export class CollectorService {
    private readonly apiClientService = inject(ApiClientService);

    importAtgarderFromCollector(request: ICollectorImportAtgarderRequest): Observable<ICollectorImportAtgarderResponse> {
        return this.apiClientService.post<ICollectorImportAtgarderRequest, ICollectorImportAtgarderResponse>("virkeskop/collector/import/atgard", request, false);
    }

    importDrivningslinjerFromCollector(request: ICollectorImportDrivningslinjerRequest): Observable<ICollectorImportDrivningslinjerResponse> {
        return this.apiClientService
            .post<ICollectorImportDrivningslinjerRequest, ICollectorImportDrivningslinjerResponse>("virkeskop/collector/import/drivningslinje", request, false);
    }

    importDrivningspunkterFromCollector(request: ICollectorImportDrivningspunkterRequest): Observable<ICollectorImportDrivningspunkterResponse> {
        return this.apiClientService
            .post<ICollectorImportDrivningspunkterRequest, ICollectorImportDrivningspunkterResponse>("virkeskop/collector/import/drivningspunkt", request, false);
    }

    importHansynsytorFromCollector(request: ICollectorImportHansynsytorRequest): Observable<ICollectorImportHansynsytorResponse> {
        return this.apiClientService
            .post<ICollectorImportHansynsytorRequest, ICollectorImportHansynsytorResponse>("virkeskop/collector/import/hansynsyta", request, false);
    }

    importHansynspunkterFromCollector(request: ICollectorImportHansynspunkterRequest): Observable<ICollectorImportHansynspunkterResponse> {
        return this.apiClientService
            .post<ICollectorImportHansynspunkterRequest, ICollectorImportHansynspunkterResponse>("virkeskop/collector/import/hansynspunkt", request, false);
    }

    importHansynslinjerFromCollector(request: ICollectorImportHansynslinjerRequest): Observable<ICollectorImportHansynslinjerResponse> {
        return this.apiClientService
            .post<ICollectorImportHansynslinjerRequest, ICollectorImportHansynslinjerResponse>("virkeskop/collector/import/hansynslinje", request, false);
    }

    compare(geometrierSource: IKartgeometri[], geometrierDestination: IKartgeometri[]): Observable<GeometrierDuplicateDTO[]> {

        const source = geometrierSource.map(g => ({
            guid: g.guid,
            metadata: {
                subtyp1: g.subtyp1,
                subtyp2: g.subtyp2,
                subtyp3: g.subtyp3
            },
            wkt: g.geometri
        }));
        const destination = geometrierDestination.map(g =>
            ({
                guid: g.guid,
                metadata: {
                    subtyp1: g.subtyp1,
                    subtyp2: g.subtyp2,
                    subtyp3: g.subtyp3
                },
                wkt: g.geometri
            }));
        const request = {
            source: source,
            destination: destination,
            useMetadata: true
        } as CompareGeometrierDTO;
        return this.apiClientService
            .post<CompareGeometrierDTO, GeometrierDuplicateDTO[]>("geometri/compare", request, false);
    }
}
